/* eslint-disable react/no-array-index-key */
import Slider from "component/design-system/carousel/Slider";
// import { NextArrow, PrevArrow } from "component/design-system/SlickButtons";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import Image from "next/legacy/image";
import Link from "next/link";
import HideIf from "util/HideIf";
import sliderStyles from "../HomeSliderWrapper.module.scss";
import styles from "./sponsored-brands.module.scss";

function SponsoredBrands(props: any) {
  const { brands, className = "", showName = true } = props;

  if (!brands) {
    return (
      <LoaderSkeleton
        height={200}
        gridView
        count={2}
      />
    );
  }

  return (
    <div className={styles.sponsored_brands}>

      <div className={sliderStyles.HomeSliderWrapper}>

        <Slider
          tileWidth={240}
          // autoplay
          showArrowOnHover
          showScrollOnHover
          className="d-flex justify-content-between"
          liClass={styles.li_class}
        >
          {brands.map((brand: any, index) => (
            <div key={index} className={`${styles.column_container} ${className} ${styles.single_logo}`}>
              <div key={brand.url} className={styles.slider_item}>
                <Link
                  href={brand.url}
                  title={`Enhance Your Car with ${ brand.name} Auto Parts`}
                >

                  <div className={styles.logo_container}>
                    <Image
                      src={`${process.env.NEXT_PUBLIC_CMS}/${brand.imageUrl}`}
                      alt={`Explore ${ brand.name} Premium Automotive Components`}
                      title={`Explore ${ brand.name} Premium Automotive Components`}
                      unoptimized
                      layout="fill"
                      objectFit="contain"
                    />
                  </div>
                  <HideIf show={showName}>
                    <PAText component="h3" fontSize={FONT_SIZE[1]} className="m-t-0 text-center">{brand.name}</PAText>
                  </HideIf>

                </Link>
              </div>

            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
export default SponsoredBrands;
